/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import {
    NOTIFY,
    FETCH_DATA,
    FETCH_COMPLETE,
    UPDATE_VALUE,
    SAVE_CUSTOMER,
    EDITING_ITEM
} from './types';
import { suppliers,  customsHouses, users } from '../../services';

const services = {
    suppliers,
    customsHouses,
    users
}

const showErrorMessage = (dispatch, message)  => {
  onDataLoaded(dispatch, [
      { path: 'isLoading', value: false },
      { path: 'showNotification', value: true},
      { path: 'showMessage', value:   message },
      { path: 'notificationColor', value: 'red' }
  ]);
};

//TODO params (service, stateProperty, URL, paramas)
export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, [
                  { path: 'numPages', value: result.page.totalPages },
                  { path: 'activePage', value: result.page.number },
                  { path, value: result._embedded.suppliers },
                  { path: 'isLoading', value: false }
              ]);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

const onDataLoaded = (dispatch, targets) => {
    dispatch({
        type: NOTIFY,
        payload: { op: 'multiUpdate', targets }
    });
};



export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};

export const saveSupplier = (newSupplier) => {
    newSupplier = {
        ...newSupplier,
        address: {
            street: newSupplier.street,
            externalNumber: newSupplier.externalNumber,
            internalNumber: newSupplier.internalNumber,
            zipCode: newSupplier.zipCode,
            colony: newSupplier.colony,
            city: newSupplier.city,
            state: newSupplier.state,
            country: newSupplier.country,
            municipality: newSupplier.municipality
        }
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["suppliers"].post("suppliers?projection=denormalizedSupplier", newSupplier).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado nuevo cliente a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'suppliers', value: result }});
            }else {
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};


export const editSupplier = (editedSupplier, index) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["suppliers"].put("suppliers/" + editedSupplier.id + "?projection=denormalizedSupplier", editedSupplier).then(result => {
            if(typeof(result.response) === "undefined"){
              //Añado nuevo cliente a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'suppliers', value: { index, value: result } } });
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const deleteSupplier = (supplierToRemove, index) =>{
  return (dispatch) => {
      dispatch({ type: FETCH_DATA });
      return services['suppliers'].Delete('suppliers/'+ supplierToRemove.id).then(result => {
          onDataLoaded(dispatch, [
              { path: 'isLoading', value: false },
              { path: 'showNotification', value: true},
              { path: 'showMessage', value: result.message },
              { path: 'notificationColor', value: result.color }
         ]);
         if(result.color=== '#04B404'){
           dispatch({ type: FETCH_COMPLETE, payload: { op: 'remove', path: 'suppliers', value: index } });
         }
      });
  };
};



// WEBPACK FOOTER //
// ./containers/proveedores/actions.js